import { useContext } from 'react';
import { SkeletonCardDescription, SkeletonCardNR1Container, SkeletonCardTitle, SkeletonCardValue } from './SkeletonCardNr1.styles';
import ThemeOptionContext from '../../context/theme-option/ThemeOptionContext';

export const SkeletonChartNR1 = () => {
    const { state: themeState } = useContext(ThemeOptionContext);
    return (
        <>
            <SkeletonCardNR1Container themeState={themeState}>
                <SkeletonCardValue variant="text" width="30%" height={52} />
                <SkeletonCardTitle variant="text" width="80%" height={24} />
                <SkeletonCardDescription variant="text" width="100%" height={16} />
                <SkeletonCardDescription variant="text" width="60%" height={16} />
            </SkeletonCardNR1Container>

            <SkeletonCardNR1Container themeState={themeState}>
                <SkeletonCardValue variant="text" width="30%" height={52} />
                <SkeletonCardTitle variant="text" width="85%" height={24} />
                <SkeletonCardDescription variant="text" width="100%" height={16} />
                <SkeletonCardDescription variant="text" width="70%" height={16} />
            </SkeletonCardNR1Container>

            <SkeletonCardNR1Container themeState={themeState}>
                <SkeletonCardValue variant="text" width="20%" height={52} />
                <SkeletonCardTitle variant="text" width="90%" height={24} />
                <SkeletonCardDescription variant="text" width="100%" height={16} />
                <SkeletonCardDescription variant="text" width="65%" height={16} />
            </SkeletonCardNR1Container>
        </>
    );
};